"use client";

import { colours } from "@shared/ui.design-system";
import { Link } from "@shared/ui.primitives";
import { getDerivedLocale } from "@shared/utils.locale";
import React from "react";

import { useTrustPilotWidget } from "./TrustPilotWidget.hooks";
import { trustPilotConfig } from "./constants";

type Props = {
  textColor?: string;
};

export const TrustPilotRatingWidget: React.FC<Props> = ({
  textColor = colours.secondary.light
}): JSX.Element => {
  const { trustPilotContainerRef } = useTrustPilotWidget();
  const locale = getDerivedLocale();

  return (
    <div
      ref={trustPilotContainerRef}
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={trustPilotConfig["new-data-template-id"]}
      data-businessunit-id={trustPilotConfig["data-businessunit-id"][locale]}
      data-style-height="20px"
      data-style-width="100%"
      data-theme={textColor === colours.secondary.light ? "dark" : "light"}
      data-text-color={textColor}
    >
      <Link href={trustPilotConfig.url[locale]} target="_blank">
        Trustpilot
      </Link>
    </div>
  );
};
